import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FieldMobilePhoneProps {
    mobilePhone: string;
}

export default function FieldMobilePhone({ mobilePhone }: FieldMobilePhoneProps) {
    const { t } = useTranslation('profile');

    return (
        <TextField
            disabled
            label={ t('fields.mobilePhone') }
            value={ mobilePhone }
        />
    );
}
